"use strict";

const getCurrentScriptOrigin = () => {
  var _document$currentScri;
  if (typeof document === 'undefined') {
    return '/';
  }
  return ((_document$currentScri = document.currentScript) === null || _document$currentScri === void 0 ? void 0 : _document$currentScri.baseURI) || '/';
};
__webpack_public_path__ = getCurrentScriptOrigin();